module.exports = __webpack_public_path__ + "static/media/plotSvg.466c305a.svg";